import { render } from "./WrongPage.vue?vue&type=template&id=4a9a4d04&scoped=true"
const script = {}

import "./WrongPage.vue?vue&type=style&index=0&id=4a9a4d04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9a4d04"]])

export default __exports__